import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closeDrawerButtonAriaLabel: {
    defaultMessage: 'Close Create Advance Shipping Notice Drawer',
    id: 'vQb8N8',
    description: 'aria label to close Create Advance Shipping Notice Drawer',
  },
  createAdvancedShippingNoticeTitle: {
    defaultMessage: 'Create Advance Shipping Notice',
    id: '9MqPvR',
    description: 'Create Advance Shipping Notice title for drawer',
  },
  createAdvancedShippingNoticeSubtitle: {
    defaultMessage: 'Complete the following steps to issue an advance shipping notice.',
    description: 'Subtitle description for the ASN drawer.',
    id: 'wg8xmn',
  },
  submittedAdvancedShippingNoticeTitle: {
    defaultMessage: 'Advance Shipping Notice Submitted',
    id: 'EckcEG',
    description: 'Submitted Advance Shipping Notice title for drawer',
  },
  receivedAdvancedShippingNoticeSubtitle: {
    defaultMessage: 'Your ASN has been submitted {icon}',
    id: '3im2Vj',
    description: 'Submitted Advance Shipping Notice title for drawer telling a user their ASN is received',
  },
  completedAdvancedShippingNoticeTitle: {
    defaultMessage: 'Advance Shipping Notice Completed',
    id: 'lMtrDZ',
    description: 'Completed Advance Shipping Notice title for drawer',
  },
  completedAdvancedShippingNoticeSubtitle: {
    defaultMessage: 'Your ASN has been completed {icon}',
    description: 'Subtitle description for the ASN drawer.',
    id: 'OmzSUN',
  },
  cancelledAdvancedShippingNoticeTitle: {
    defaultMessage: 'Advance Shipping Notice Cancelled',
    id: 'z920BL',
    description: 'Cancelled Advance Shipping Notice title for drawer',
  },
  cancelledAdvancedShippingNoticeSubtitle: {
    defaultMessage: 'Your ASN has been cancelled',
    description: 'Subtitle description for the ASN drawer.',
    id: 'EZoine',
  },
  errorNotificationOpenASNTitle: {
    defaultMessage: 'Unable to Create Advance Shipping Notice',
    id: 'YLn2sJ',
    description: 'Open ASN Drawer - Notification Error Title',
  },
  errorNotificationOpenASNMessage: {
    defaultMessage:
      'It looks like your account does not have access to Fulfilled by ShipStation. Please set it up if you would like to use this service',
    id: '0UEFZM',
    description: 'Open ASN Drawer - Notification Error message body',
  },
  errorNotificationUpdateTitle: {
    defaultMessage: 'Error Updating Advance Shipping Notice',
    id: 'GalGe8',
    description: 'Update ASN - Notification Error Title',
  },
  errorNotificationUpdateMessage: {
    defaultMessage: 'An error occurred updating an Advance Shipping Notice. Please try again.',
    id: 'QzMC80',
    description: 'Update ASN - Notification Error message body',
  },
  errorNotificationSubmitTitle: {
    defaultMessage: 'Error Submitting Advance Shipping Notice',
    id: 'i7+s6C',
    description: 'Update ASN - Notification Error Title',
  },
  errorNotificationSubmitMessage: {
    defaultMessage: 'An error occurred submitting your Advance Shipping Notice. Please try again.',
    id: 'nmUUaF',
    description: 'Update ASN - Notification Error message body',
  },
  successNotificationSubmitTitle: {
    defaultMessage: 'Successfully Submitted Advance Shipping Notice',
    id: 'rBzSs4',
    description: 'Update ASN - Notification Success Title',
  },
  successNotificationSubmitMessage: {
    defaultMessage: 'Congratulations! Your ASN has been submitted. Please review your shipping notice for next steps.',
    id: 'kXAmZy',
    description: 'Update ASN - Notification Success message body',
  },
  createdAt: {
    defaultMessage: 'Date Created: {date}',
    id: 'Hz3jet',
    description: 'A seller formatted string informing user when they created the ASN',
  },
  purchaseOrderNumber: {
    defaultMessage: 'Order Number: {orderNumber}',
    id: 'SnDhgr',
    description: 'Text to inform the user what the order number is for their ASN',
  },
  receivingId: {
    defaultMessage: 'Receiving ID: {receivingId}',
    id: 'QECYvR',
    description: 'Text to inform the user what the ShipBob WRO (Warehouse Receiving Order) number is for their submitted ASN',
  },
  draft: {
    defaultMessage: 'Draft',
    id: 'W9u5ye',
    description: 'Text to inform the user the ASN is still in Draft mode',
  },
  successNotificationFreightFormTitle: {
    defaultMessage: 'Successfully Submitted Freight Form',
    id: 'ewUmNG',
    description: 'Notification Success Title for Freight Form',
  },
  successNotificationFreightFormMessage: {
    defaultMessage:
      'Congratulations! Your freight form has been successfully submitted. Please review your shipping notice for next steps.',
    id: 'gNOLYs',
    description: 'Notification Success message body for Freight Form',
  },
  errorNotificationFreightFormTitle: {
    defaultMessage: 'Error Submitting Freight Form',
    id: 'AyHexH',
    description: 'Notification Error Title for Freight Form',
  },
  errorNotificationFreightFormMessage: {
    defaultMessage: 'An error occurred submitting your freight form. Please try again.',
    id: 'Vq3OsQ',
    description: 'Notification Error message body for Freight Form',
  },
  errorNotificationWarehousesTitle: {
    defaultMessage: 'Error Fetching Warehouses',
    id: 'E0tQ6L',
    description: 'Notification Error Title for Warehouse Fetching',
  },
  errorNotificationWarehousesMessage: {
    defaultMessage: 'An error occurred fetching warehouses. Please close and reopen the Advance Shipping Notice you wish to edit',
    id: 'y2OBWP',
    description: 'Notification Error message body for Warehouse Fetching',
  },
});
